import { Stack } from '@mui/material';
import StockCountCreateMain from './components/StockCountCreateMain';
import StockCountCreatePopUps from './components/StockCountCreatePopUps';
import { StockCountCreateProvider } from './contexts/StockCountCreateContext';
import StockCountCreateTop from './components/StockCountCreateTop';
import StockCountCreateItems from './components/StockCountCreateItems';
import StockCountScheduleCreateCategories from './components/StockCountCreateCategories';
import PageArea from '../../components/shared/PageArea';
import StockCountProductTypes from './components/StockCountProductTypes';
import StockCountCreateCountZoneTypes from './components/StockCountCreateCountZoneTypes';
import StockCountCreateCountZones from './components/StockCountCreateCountZones';

const StockCountCreate=() => {
  return (
    <StockCountCreateProvider>
      <PageArea>
        <Stack spacing={5}>
          <StockCountCreateTop/>
          <StockCountCreateMain />
          <StockCountCreateCountZoneTypes />
          <StockCountCreateCountZones />
          <StockCountScheduleCreateCategories/>
          <StockCountProductTypes/>
          <StockCountCreateItems/>
        </Stack>
        <StockCountCreatePopUps/>
      </PageArea>
    </StockCountCreateProvider>
  );
};

export default StockCountCreate;